import script from "./ModuleRotationCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleRotationCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleRotationCalendar.vue?vue&type=style&index=0&id=19fcbe31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19fcbe31"]])

export default __exports__